import { createContext } from 'react';

export default createContext<HTMLDivElement | null>(null);
